module.exports = __webpack_public_path__ + "img/amazon.558a7c6c.svg";